/**
 * FASWORLD announcement — quiet rotating messages
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const parseSpeed = (root) => {
    const raw = getComputedStyle(root).getPropertyValue('--fw-announcement-speed').trim();
    const seconds = Number.parseFloat(raw);
    return Number.isFinite(seconds) && seconds >= 3 ? seconds : 5;
  };

  const initAnnouncement = (root) => {
    if (!root || root.dataset.fwAnnouncementReady === 'true') return;

    const items = [...root.querySelectorAll('.fw-announcement__item')];
    if (!items.length) return;

    root.dataset.fwAnnouncementReady = 'true';
    items.forEach((item) => item.classList.remove('is-active'));
    items[0].classList.add('is-active');

    if (items.length < 2 || reduceMotion.matches) return;

    const speedMs = parseSpeed(root) * 1000;
    let index = 0;
    let timer = null;

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (reduceMotion.matches || document.hidden) return;
      stop();
      timer = window.setInterval(() => {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, speedMs);
    };

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    reduceMotion.addEventListener?.('change', () => {
      if (reduceMotion.matches) stop();
      else start();
    });

    start();
  };

  const boot = (root = document) => {
    root.querySelectorAll('[data-fw-announcement]').forEach(initAnnouncement);
  };

  if (!window.__fwAnnouncementListeners) {
    window.__fwAnnouncementListeners = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (event) => {
      boot(event.target);
    });
  } else if (document.readyState !== 'loading') {
    boot();
  }
})();
